import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        url: '/',
        url_api: '/api/administrator/',

        api_route: {
            forMom: 'forMom',
            komen: 'komen',
            homepage: 'homepage',
            artiPro: 'arti-pro',
            faq: 'faq',
            auth: 'auth',

            user: 'user',
            'user.how_know': 'user/howKnow',

            dashboard: 'dashboard',
            type: 'type',
            occasion: 'occasion',
            country: 'country',
            century: 'century',
            tag: 'tag',
            document: 'document',
            value: 'value',
            unit: 'unit',
            valuation: 'valuation',
            violationReports: 'violation-reports',
            artifact: 'artifact',

            circle_list: 'circleList',
            sharing_list: 'sharingList',

            'marketing.qr_code': 'qrCode',
            'marketing.qr_code.generate': 'qrCode/generate',
            'marketing.qr_code.export': 'qrCode/export',

            'marketing.promo_code': 'promoCode',
            'marketing.promo_code.generate': 'promoCode/generate',
            'marketing.promo_code.getQRCode': 'promoCode/getQRCode',
            'marketing.partner_promo_code': 'partnerCode',
            'marketing.partner_promo_code.generate': 'partnerCode/generate',
            'marketing.partner_promo_code.generate_list': 'partnerCode/generateList',
            'marketing.partner_promo_code.generate_report_list': 'partnerCode/generateReportList',

            administrator: 'administrator',
            adminRole: 'adminRole',
            adminPermission: 'adminPermission',
            content: 'content',

            plan: 'plan',
            plan_description: 'planDescription',
            plan_permission: 'planPermission',
            subscription: 'subscription',
            subscription_gift: 'subscriptionGift',
            transaction: 'transaction',
            concierge_service: 'conciergeService',

            blog_category: 'blogCategory',
            blog_post: 'blogPost',
            blog_post_upload_image: 'blogPostUploadImage',

            email_subscriptions: 'email-subscriptions',

            company: 'company',
            'companies.export': 'company/export',

            'company.request': 'company-request',
            forProfessionals: 'forProfessionals',
            artiProMembership: 'artiProMembership',

            brainHealth: 'brain-health',
        },
        api_token: null,
        loadingData: false,
        errorNotify: null,
        successNotify: null,
        notifyConfirm: {
            content: null,
            action: null
        },
        notification: null,
        systemTitle: 'Artifcts',
        dashboardTitle: 'Панель управления',
        user: {
            short_name: ''
        },
        userPermissions: [],
        userRoles: [],
    },
    actions: {
        AUTH_LOGIN ({ commit }, payload) {
            commit('AUTH_LOGIN', payload)
        },
        AUTH_LOGOUT ({ commit }) {
            commit('AUTH_LOGOUT')
        }
    },
    mutations: {
        AUTH_LOGIN(state, payload) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + payload
            Vue.$cookies.set('api_token', payload)
            state.api_token = payload
        },
        AUTH_LOGOUT(state) {
            Vue.$cookies.remove('api_token')
            state.api_token = null
        },
        setUser(state, payload) {
            state.user = payload
        },
        setRoles(state, payload) { state.userRoles = payload },
        setPermissions(state, payload) { state.userPermissions = payload },
        setDashboardTitle(state, payload) {
            document.title = payload + ' | Admin | Artifcts.com' ?? 'Admin | Artifcts.com'
            state.dashboardTitle = payload
        },
        setApiToken(state, payload) {
            state.api_token = payload
        },
        setErrorMessage(state, payload) {
            state.errorNotify = payload
        },
        setSuccessMessage(state, payload) {
            state.successNotify = payload
        },
        setNotification(state, payload) {
            payload.id = Math.random() + '_' + Date.now()
            state.notification = payload
        },
        setLoading(state, payload) {
            state.loadingData = payload
        }
    },
    getters: {
        isAuthenticated: state => {
            return !!state.api_token
        },
        getLoading: state => {
            return state.loadingData
        },
        getErrorMessage: state => {
            return state.errorNotify
        },
        getNotification: state => {
            return state.notification
        },
        getSuccessMessage: state => {
            return state.successNotify
        },
        getDashboardTitle: state => {
            return state.dashboardTitle
        },
        getApiUrl: state => (type, param = null) => {
            if (param !== null) {
                return state.url_api + state.api_route[type] + '/' + param
            } else {
                return state.url_api + state.api_route[type];
            }
        },
        checkPermission: state => (key) => {
            if (state.userRoles.includes('super_admin')) {
                return true
            }
            if (state.userPermissions.includes(key)) {
                return true
            }
            return false
        },
        getApiToken: state => {
            return state.api_token;
        },
    }
})
